import React from 'react';

const CompletionSummary = ({ total, completed, awaiting, label }) => {
  const percent = total > 0 ? (completed / total) * 100 : null;
  return (
    <div className="grid items-center gap-5 md:grid-cols-[225px_minmax(0,1fr)] md:gap-8">
      <div>
        <p className="text-[44px] font-semibold leading-tight tracking-[-1.5px] text-emerald-800">
          {completed.toLocaleString('fr-FR')}
          <span className="text-[26px] font-normal tracking-[-0.7px] text-slate-500">
            {' '}
            / {total.toLocaleString('fr-FR')}
          </span>
        </p>
        <p className="mt-2 text-sm text-slate-500">{label}</p>
      </div>
      <div>
        <div className="mb-2 flex justify-between gap-3">
          <strong className="text-2xl text-emerald-700">
            {percent == null
              ? '—'
              : `${percent.toLocaleString('fr-FR', {
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 1,
                })} %`}
          </strong>
          <span className="text-sm text-slate-500">
            <strong className="text-slate-900">{awaiting.toLocaleString('fr-FR')}</strong> en attente
          </span>
        </div>
        <div className="h-2.5 overflow-hidden rounded-[3px] bg-slate-100" aria-hidden="true">
          <div className="h-full bg-emerald-700" style={{ width: `${percent || 0}%` }} />
        </div>
      </div>
    </div>
  );
};
export default CompletionSummary;
